import { OnDestroy, OnInit, } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ABTest } from '@freelancer/abtest';
import { Auth } from '@freelancer/auth';
import { Datastore, toNumber, } from '@freelancer/datastore';
import { PaymentsCart, } from '@freelancer/payments-cart';
import { TimeUtils } from '@freelancer/time-utils';
import { ModalRef } from '@freelancer/ui';
import { BannerAlertType } from '@freelancer/ui/banner-alert';
import { ButtonColor } from '@freelancer/ui/button';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { InputType } from '@freelancer/ui/input';
import { Margin } from '@freelancer/ui/margin';
import { FontType, FontWeight } from '@freelancer/ui/text';
import { maxLength, maxValue, minValueExclusive, pattern, required, } from '@freelancer/ui/validators';
import { ErrorCodeApi } from 'api-typings/errors/errors';
import { ContextTypeApi, DestinationApi } from 'api-typings/payments/payments';
import * as Rx from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
var MilestoneCreateModalComponent = /** @class */ (function () {
    function MilestoneCreateModalComponent(modalRef, auth, datastore, router, cart, abtest, timeUtils, uiConfig) {
        this.modalRef = modalRef;
        this.auth = auth;
        this.datastore = datastore;
        this.router = router;
        this.cart = cart;
        this.abtest = abtest;
        this.timeUtils = timeUtils;
        this.uiConfig = uiConfig;
        this.Margin = Margin;
        this.BannerAlertType = BannerAlertType;
        this.ButtonColor = ButtonColor;
        this.FontWeight = FontWeight;
        this.FontType = FontType;
        this.HeadingSize = HeadingSize;
        this.HeadingType = HeadingType;
        this.InputType = InputType;
        this.ErrorCodeApi = ErrorCodeApi;
        this.REDIRECT_TIMEOUT = 50;
        this.isBusy = false;
        this.showError = false;
    }
    MilestoneCreateModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        // set up input formgroup
        this.formGroup = new FormGroup({
            amount: new FormControl('', [
                required('Amount field is required'),
                minValueExclusive(0, 'Please enter a greater amount.'),
                maxValue(999999999, 'Please enter a lesser amount.'),
                pattern(/^[1-9]\d*(\.\d{1,2})?$/, 'Invalid amount specified'),
            ]),
            description: new FormControl('', [
                required('Description is required'),
                maxLength(200, 'Please create a shorter description.'),
            ]),
        });
        var project$ = this.datastore
            .document('projectViewProjects', this.projectId)
            .valueChanges();
        var isEscrowInteractionRequired$ = this.datastore
            .objects('users', this.auth
            .getUserId()
            .pipe(map(function (authUid) { return [toNumber(authUid), _this.bidderId]; })))
            .pipe(map(function (users) { return users.some(function (u) { return u.escrowComInteractionRequired; }); }));
        if (this.abtest.isWhitelistUser()) {
            this.inTest$ = Rx.of(true);
        }
        else if (this.uiConfig.theme === 'arrow') {
            this.inTest$ = Rx.of(false);
        }
        else {
            this.inTest$ = Rx.combineLatest([
                project$,
                isEscrowInteractionRequired$,
            ]).pipe(switchMap(function (_a) {
                var project = _a[0], escrowRequired = _a[1];
                // projects with local jobs not in the test
                if (project.local && !escrowRequired) {
                    return Rx.of(false);
                }
                return Rx.of(true);
            }));
        }
        var employerProfile$ = this.datastore
            .document('usersProfile', project$.pipe(map(function (project) { return project.ownerId; })))
            .valueChanges();
        this.areEscrowActionsRequired$ = Rx.combineLatest([
            employerProfile$,
            isEscrowInteractionRequired$,
        ]).pipe(map(function (_a) {
            var profile = _a[0], escrowComInteractionRequired = _a[1];
            return escrowComInteractionRequired &&
                !(profile.escrowProfileCompleted && profile.hasLinkedEscrowComAccount);
        }));
        this.areEscrowActionsRequiredSubscription = this.areEscrowActionsRequired$.subscribe(function (escrowRequired) {
            if (escrowRequired) {
                _this.timeUtils.setTimeout(function () {
                    _this.modalRef.close(false);
                    _this.router.navigate(["/projects/" + _this.projectId]);
                }, _this.REDIRECT_TIMEOUT);
            }
        });
    };
    MilestoneCreateModalComponent.prototype.ngOnDestroy = function () {
        if (this.areEscrowActionsRequiredSubscription) {
            this.areEscrowActionsRequiredSubscription.unsubscribe();
        }
    };
    // Create milestone without cart
    MilestoneCreateModalComponent.prototype.createMilestone = function () {
        var _this = this;
        this.createMilestonePromise = this.datastore
            .createObject('milestones', {
            id: Date.now(),
            projectId: this.projectId,
            bidderId: this.bidderId,
            amount: toNumber(this.formGroup.controls.amount.value),
            description: this.formGroup.controls.description.value,
            currency: this.currencyDetails,
            timeCreated: Date.now(),
        })
            .then(function (res) {
            if (res.status === 'success') {
                _this.modalRef.close(true);
            }
            else {
                if (res.errorCode === ErrorCodeApi.PAYMENT_REQUIRED) {
                    _this.modalRef.close(true);
                    // if it fails due to insufficient funds, redirect to deposit page
                    // refAction = create_milestone handles the dataToken for us
                    var queryParams = {
                        amount: toNumber(_this.formGroup.controls.amount.value),
                        bidderId: _this.bidderId,
                        currency: _this.currencyDetails.id,
                        descr: _this.formGroup.controls.description.value,
                        id: _this.projectId,
                        refAction: 'create_milestone',
                        username: _this.username,
                        checkBalance: true,
                    };
                    _this.router.navigate(['/deposit'], { queryParams: queryParams });
                }
                return res;
            }
        });
    };
    /**
     * 1. create cart
     * 2. create milestone draft
     * 3. create cart item
     * 4. add project fee cart item if hourly
     * 5. If success, to payment page, all errors in all steps show and break promise
     *
     */
    MilestoneCreateModalComponent.prototype.createMilestoneCart = function () {
        var _this = this;
        this.createMilestonePromise = this.createMilestoneDraft(this.formGroup)
            .then(function (milestoneDraftResponse) {
            if (milestoneDraftResponse.status !== 'success') {
                throw milestoneDraftResponse;
            }
            var milestoneRequestCartItem = _this.transformMilestoneRequestToCartItem(_this.formGroup, milestoneDraftResponse.id);
            return Rx.combineLatest([
                _this.datastore
                    .document('projectViewProjects', _this.projectId)
                    .valueChanges(),
                _this.datastore
                    .collection('hourlyContracts', function (query) {
                    return query
                        .where('projectId', '==', _this.projectId)
                        .where('active', '==', true)
                        .where('bidderId', '==', _this.bidderId);
                })
                    .valueChanges(),
            ])
                .pipe(take(1))
                .toPromise()
                .then(function (_a) {
                var project = _a[0], hourlyContracts = _a[1];
                // if it's hourly, we need to attach a project fee cart item
                if (project.hourlyProjectInfo && hourlyContracts.length > 0) {
                    return _this.datastore
                        .collection('hourlyProjectMilestoneFees', function (query) {
                        return query
                            .where('projectId', '==', _this.projectId)
                            .where('milestoneAmount', '==', toNumber(_this.formGroup.controls.amount.value));
                    })
                        .valueChanges()
                        .pipe(take(1), map(function (res) { return res[0]; }))
                        .toPromise()
                        .then(function (r) {
                        var fee = r.fee, currencyId = r.currencyId;
                        var projectFeeItem = _this.transformProjectFeeToCartItem(milestoneDraftResponse.id, currencyId, fee);
                        return [projectFeeItem, milestoneRequestCartItem];
                    });
                }
                return [milestoneRequestCartItem];
            });
        })
            .then(function (items) {
            return _this.cart.handle("Chat box create milestone for project " + _this.projectId, {
                destination: DestinationApi.PROJECT_VIEW_PAGE,
                payload: "" + _this.projectId,
            }, items);
        })
            .catch(function (e) { return e; });
    };
    MilestoneCreateModalComponent.prototype.createMilestoneDraft = function (milestoneForm) {
        var milestoneDraft = {
            amount: Number(milestoneForm.value.amount),
            bidderId: this.bidderId,
            bidId: this.bidId,
            currencyId: this.currencyDetails.id,
            description: milestoneForm.value.description,
            id: Date.now(),
            milestoneRequestId: undefined,
            projectId: this.projectId,
            projectOwnerId: Date.now(),
            timeCreated: Date.now(),
            transactionId: undefined,
        };
        return this.datastore.createObject('milestoneDrafts', milestoneDraft);
    };
    MilestoneCreateModalComponent.prototype.transformMilestoneRequestToCartItem = function (milestoneForm, milestoneDraftId) {
        return {
            contextType: ContextTypeApi.MILESTONE,
            contextId: String(milestoneDraftId),
            description: milestoneForm.value.description,
            currencyId: this.currencyDetails.id,
            amount: Number(milestoneForm.value.amount),
            useBonus: true,
        };
    };
    MilestoneCreateModalComponent.prototype.transformProjectFeeToCartItem = function (milestoneDraftId, currencyId, fee) {
        return {
            contextType: ContextTypeApi.PROJECT_FEE,
            contextId: "" + milestoneDraftId,
            description: 'Project fee',
            currencyId: currencyId,
            amount: fee,
            useBonus: false,
        };
    };
    MilestoneCreateModalComponent.prototype.cancel = function () {
        this.modalRef.close(false);
    };
    return MilestoneCreateModalComponent;
}());
export { MilestoneCreateModalComponent };
